<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getMinTimeGeoJson.data.id"
      :source="getMinTimeGeoJson"
      :layerId="getMinTimeLineLayer.id"
      :layer="getMinTimeLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getMinTimeGeoJson.data.id"
      :source="getMinTimeGeoJson"
      :layerId="getMinTimePointsLayer.id"
      :layer="getMinTimePointsLayer"
    />
  </div>
</template>
    
    <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "MinTimeLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", ["getMinTimeGeoJson"]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getMinTimeLineLayer",
      "getMinTimePointsLayer",
    ]),
  },
};
</script>